export default {
  studyMap_accumulated_class:'累計學時',
  studyMap_grantee:'被授予人',
  studyMap_relearning:'重新學習',
  studyMap_show_certificate:'1105Web-顯示結業證書',
  studyMap_check_learn_map0406:'0406Web-查看學習地圖',
  studyMap_show_learn_map0405:"0405Web-顯示我的學習地圖列表",
  studyMap_check_top:'查看排名',
  studyMap_continue_customs:'繼續通關',
  studyMap_show_level_rank:'1104Web-顯示關卡排名',
  studyMap_go_task_finished:'你已前往任務學習，是否已完成學習？',
  studyMap_resource_invalid:'資源已失效',
  studyMap_accompany_training_task:'陪練任務',
  studyMap_switch_task_level:'1102Web-切換任務關卡',
  studyMap_check_task_top:'1103Web-查看關卡排名',
  studyMap_current_level:'第{TabEnum}關',
  studyMap_show_learn_map1101:'1101Web-顯示學習地圖詳情',
  studyMap_one:'一',
  studyMap_two:'二',
  studyMap_three:'三',
  studyMap_four:'四',
  studyMap_five:'五',
  studyMap_six:'六',
  studyMap_seven:'七',
  studyMap_eigth:'八',
  studyMap_nine:'九',
  studyMap_ten:'十',
  studyMap_eleven:'十一',
  studyMap_twelve:'十二',
  studyMap_thirteen:'十三',
  studyMap_fourteen:'十四',
  studyMap_fifteen:'十五',
  studyMap_ID_cannot_empty:"階段學習項目id不能為空!",
  studyMap_learn_invalid:'階段學習項目已失效!',
  studyMap_without_right:'沒有權限!'
}
